import { ReactNode, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { StyledPageWrapper } from 'components/new-ui/base/wrappers/styles';
import PageHeader from 'components/new-ui/base/page-header/PageHeader';
import { getActiveInvoiceConfigTabKey, InvoiceConfigTabKeys } from './getActiveTabKey';
import { StyledTabs } from 'components/new-ui/base/tabs/styles';
import useInvoicesConfig from 'hooks/useInvoicesConfig';

interface Props {
    children: ReactNode;
}

const InvoiceConfigPage = ({ children }: Props) => {
    const { getConfig } = useInvoicesConfig();
    const navigate = useNavigate();
    const location = useLocation();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const activeTabKey = useMemo(() => getActiveInvoiceConfigTabKey(location), [location.pathname]);

    const tabItems = useMemo(
        () => [
            {
                key: InvoiceConfigTabKeys.GENERAL_SETTINGS,
                label: 'General Settings',
            },
            {
                key: InvoiceConfigTabKeys.ADDITIONAL_CHARGES,
                label: 'Additional Charges',
            },
        ],
        []
    );

    // Load the config in redux so it is available in the tabs
    useEffect(() => {
        getConfig();
    }, [getConfig]);

    return (
        <StyledPageWrapper>
            <PageHeader showBackButton title="Configure Invoices" icon={null} onBackButtonClick={() => navigate(-1)} />

            <StyledTabs
                style={{ marginTop: 24 }}
                activeKey={activeTabKey}
                onChange={(key) => {
                    const baseUrl = `/invoices/config`;
                    const to = key === InvoiceConfigTabKeys.GENERAL_SETTINGS ? baseUrl : `${baseUrl}/${key}`;
                    navigate(to, { replace: true });
                }}
                items={tabItems}
            />

            {children}
        </StyledPageWrapper>
    );
};

export default InvoiceConfigPage;
